<template>
    <div class="container" v-show="show" >
        <div id="message" class="alert " :class="'alert-'+level" role="alert" >
            {{body}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click.prevent="dismiss">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Flash',
        props: ['message'],
        data() {
            return {
                body: '',
                level: 'success',
                show: false
            }
        },
        created() {
            if (this.message) {
                this.flash(this.message);
            }

            window.events.$on( 
                'flash', data  => this.flash(data)
            );
        },
        methods: {
            flash(data) {
                this.body = data.message;
                this.level = data.level;
                this.show = true;

                this.hide();
            },

            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 3000);
            },
            
            dismiss() {
                this.show = false;
            },
        }
    }
</script>